export default {
    common: {
        save: "Lưu",
        saving: "Đang lưu...",
        cancel: "Hủy",
        delete: "Xóa",
        edit: "Sửa",
        add: "Thêm",
        search: "Tìm kiếm",
        filter: "Lọc",
        success: "Thành công",
        error: "Lỗi",
        confirm: "Xác nhận",
        back: "Quay lại",
        loading: "Đang tải...",
        loadMore: "Tải thêm",
        actions: "Thao tác",
        create: "Tạo mới",
        creating: "Đang tạo...",
        required: "là bắt buộc",
        confirmDelete: "Xác nhận xóa",
        accessDenied: "Truy cập bị từ chối",
        noPermission: "Bạn không có quyền truy cập vào trang này",
        dangerZone: "Vùng nguy hiểm",
        close: "Đóng",
        refresh: "Làm mới",
        noData: "Không có dữ liệu",
        view: "Xem",
        update: "Cập nhật",

        // Web
        cart: "Giỏ hàng",
        call: "Gọi ngay",
        processing: "Đang xử lý...",
        english: "English",
        vietnamese: "Tiếng Việt",
        backToHome: "Quay lại trang chủ",
        continueShopping: "Tiếp tục mua sắm",
    },
    auth: {
        login: {
            title: "Đăng nhập",
            email: "Email",
            verificationCode: "Mã xác thực",
            requestCode: "Nhận mã xác thực",
            signIn: "Đăng nhập",
            codeSent: "Mã xác thực đã được gửi đến {{email}}",
            tryAnotherEmail: "Thử với Email khác",
            resendCode: "Gửi lại mã",
            emailRequired: "Email là bắt buộc",
            invalidEmail: "Định dạng email không hợp lệ",
            codeRequired: "Mã xác thực là bắt buộc",
            invalidCode: "Mã xác thực không hợp lệ",
        },
    },
    config: {
        title: "Cài đặt hệ thống",
        language: "Ngôn ngữ hệ thống",
        languageLabel: "Ngôn ngữ",
        saveButton: "Lưu cài đặt",
        saveSuccess:
            "Lưu thành công! Ngôn ngữ sẽ được áp dụng cho toàn hệ thống.",
        saveError: "Đã xảy ra lỗi khi lưu cài đặt. Vui lòng thử lại.",
        languageChangeError: "Không thể thay đổi ngôn ngữ",
    },
    menu: {
        post: "Bài viết",
        product: "Sản phẩm",
        order: "Đơn hàng",
        storage: "Lưu trữ",
        chat: "Trò chuyện",
        config: "Cài đặt",
        users: "Người dùng",
        database: "Cơ sở dữ liệu",

        // Web
        home: "Trang chủ",
        about: "Giới thiệu",
        contact: "Liên hệ",
        products: "Sản phẩm",
    },
    login: {
        title: "Đăng nhập",
        email: "Email",
        password: "Mật khẩu",
        loginButton: "Đăng nhập",
        forgotPassword: "Quên mật khẩu?",
        invalidCredentials: "Email hoặc mật khẩu không đúng.",
    },
    product: {
        title: "Quản lý sản phẩm",
        addNew: "Thêm sản phẩm mới",
        createNew: "Tạo sản phẩm mới",
        editProduct: "Sửa sản phẩm",
        pageSize: "Số sản phẩm mỗi trang",
        noProductsFound:
            'Không tìm thấy sản phẩm. Tạo sản phẩm đầu tiên bằng cách nhấn "Thêm sản phẩm mới".',
        name: "Tên sản phẩm",
        price: "Giá",
        category: "Danh mục",
        stock: "Tồn kho",
        description: "Mô tả",
        image: "Hình ảnh",
        intro: "Giới thiệu",
        seoSlug: "SEO Slug",
        seoSlugHelp:
            "Tên thân thiện với URL cho trang sản phẩm. Để trống để tự động tạo.",
        created: "Ngày tạo",
        loadingError: "Không thể tải dữ liệu sản phẩm",
        deleteConfirm: "Bạn có chắc chắn muốn xóa sản phẩm này?",
        deleteSuccess: "Đã xóa sản phẩm thành công",
        deleteError: "Không thể xóa sản phẩm",
        createSuccess: "Đã tạo sản phẩm thành công",
        createError: "Không thể tạo sản phẩm",
        detail: {
            title: "Chi tiết sản phẩm",
            media: "Media",
            info: "Thông tin",
            config: "Cấu hình",
            variants: "Biến thể",
            basicInfo: "Thông tin cơ bản",
            productName: "Tên sản phẩm",
            slug: "Slug URL",
            generateSlug: "Tạo URL tự động",
            slugPlaceholder: "Nhập URL thân thiện",
            slugHelperText:
                "Được sử dụng trong URL sản phẩm. Để trống để tự động tạo từ tên.",
            slugGenerated: "Slug đã được tạo từ tên sản phẩm",
            noHeadlineForSlug: "Vui lòng nhập tên sản phẩm trước",
            price: "Giá",
            prediscountPrice: "Giá gốc",
            content: "Nội dung",
            intro: "Giới thiệu",
            introPlaceholder: "Viết giới thiệu ngắn về sản phẩm tại đây...",
            introHelperText: "Giới thiệu ngắn hiển thị ở đầu trang sản phẩm",
            contentPlaceholder: "Viết mô tả chi tiết sản phẩm tại đây...",
            contentHelperText: "Mô tả chính hiển thị ở trang sản phẩm",
            uploadMedia: "Tải lên media",
            dragToUpload: "Kéo thả tệp hoặc nhấp để tải lên",
            uploading: "Đang tải lên...",
            viewMode: "Chế độ xem",
            grid: "Lưới",
            list: "Danh sách",
            attributes: "Thuộc tính",
            attributeName: "Tên thuộc tính",
            attributeValues: "Giá trị thuộc tính",
            attributeValuesHint: "Nhập các giá trị cách nhau bởi dấu phẩy",
            addAttribute: "Thêm thuộc tính",
            editAttribute: "Sửa thuộc tính",
            attributeAdded: "Đã thêm thuộc tính thành công",
            attributeUpdated: "Đã cập nhật thuộc tính thành công",
            noAttributes:
                "Không có thuộc tính nào được định nghĩa. Thêm thuộc tính để tạo biến thể sản phẩm.",
            variantActive: "Kích hoạt",
            variantLock: "Khóa",
            variantOptions: "Tùy chọn",
            productVariants: "Biến thể sản phẩm",
            noVariants:
                "Không có biến thể nào. Thêm thuộc tính trước để tạo biến thể.",
            regenerateVariants: "Tạo lại biến thể",
            setAsMain: "Đặt làm hình chính",
            generalInfo: "Thông tin chung",
            variantInfo: "Thông tin biến thể",
            selectMedia: "Chọn media",
            updatePrice: "Cập nhật giá",
            fileTypes: "JPG, PNG, GIF, WEBP tối đa 10MB",
            deleteVariant: "Xóa biến thể",
            generateVariants: "Tạo biến thể",
            addMediaToVariant: "Thêm media vào biến thể",
            addMoreMedia: "Thêm media khác",
            mediaAdded: "Đã thêm media vào biến thể",
            mediaAlreadyAdded: "Media này đã được thêm vào biến thể",
            mediaRemoved: "Đã xóa media",
            noMedia:
                "Không có tệp media nào được gắn với sản phẩm này. Tải lên tệp bằng nút ở trên.",
            variantColumn: "Biến thể",
            mediaColumn: "Media",
            priceColumn: "Giá",
            statusColumn: "Trạng thái",
            saveSuccess: "Đã lưu sản phẩm thành công",
            saveError: "Đã xảy ra lỗi khi lưu sản phẩm",
            mediaUploadSuccess: "Đã tải lên media thành công",
            mediaUploadError: "Đã xảy ra lỗi khi tải lên media",
            mediaDeleteSuccess: "Đã xóa media thành công",
            mediaDeleteError: "Đã xảy ra lỗi khi xóa media",
            confirmDeleteVariant: "Bạn có chắc muốn xóa biến thể này?",
            confirmDeleteAttribute: "Bạn có chắc muốn xóa thuộc tính này?",
            attributeDeleteSuccess: "Đã xóa thuộc tính thành công",
            urlCopied: "Đã sao chép URL vào bộ nhớ tạm",
            view: "Xem",
            priceRequired: "Không thể kích hoạt biến thể không có giá",
            priceActiveRequired: "Biến thể có giá phải được kích hoạt",
            noPriceLockedRequired:
                "Biến thể không có giá phải bị khóa hoặc không kích hoạt",
            variantsRegenerated: "Đã tạo lại biến thể",
            mediaNotFound: "Không tìm thấy media",

            // New keys for API integration
            apiUpdateError: "Lỗi kết nối với máy chủ",
            variantUpdateError: "Không thể cập nhật biến thể",
            variantStatusError: "Không thể cập nhật trạng thái biến thể",
            variantLockError: "Không thể cập nhật khóa biến thể",
            mediaLinkError: "Không thể liên kết media với biến thể",
            mediaUnlinkError: "Không thể gỡ bỏ media khỏi biến thể",
            attributeDeleteError: "Không thể xóa thuộc tính",
            attributeAddError: "Không thể thêm thuộc tính",
            unsupportedFileType: "Định dạng file không được hỗ trợ",
            supportedFileTypes: "Các định dạng được hỗ trợ",
            seeDocumentation: "Xem tài liệu về các định dạng được hỗ trợ",
            deleteMediaConfirm: "Bạn có chắc chắn muốn xóa media này?",

            // New keys for upload panel
            selectedFiles: "File đã chọn",
            uploadFiles: "TẢI LÊN FILE",
            clear: "Xóa",
            pending: "Chờ xử lý",
            uploading: "Đang tải lên",
            completed: "Hoàn thành",
            error: "Lỗi",
            remove: "Xóa",
            fileTypeCategory: {
                IMAGE: "Hình ảnh",
                AUDIO: "Âm thanh",
                VIDEO: "Video",
                DOCUMENT: "Tài liệu",
                UNKNOWN: "Không rõ",
            },
            
            // Filename validation
            filenameRules: "Tên file chỉ được chứa chữ cái tiếng Anh, số, dấu gạch ngang (-) và gạch dưới (_). Không được chứa khoảng trắng hoặc ký tự đặc biệt.",
            invalidName: "Tên không hợp lệ",
            invalidFilenamesError: "{{count}} file có tên không hợp lệ. Chỉ cho phép chữ cái tiếng Anh, số, dấu gạch ngang (-) và gạch dưới (_).",
            spaces: "khoảng trắng",
            nonEnglishChars: "ký tự tiếng Việt có dấu",
            specialChars: "ký tự đặc biệt",
            invalidCharsDetected: "Phát hiện ký tự không hợp lệ: {{chars}}",

            unsupportedFileType: "Định dạng file không được hỗ trợ",
            supportedFileTypes: "Các định dạng được hỗ trợ",
            seeDocumentation: "Xem tài liệu về các định dạng được hỗ trợ",
            uploadProgress: "Tiến độ tải lên",
            uploadComplete: "Tải lên hoàn tất",
            uploadFailed: "Tải lên thất bại",
            chooseFiles: "Chọn file",
            dragOrClick: "Kéo thả file vào đây hoặc nhấp để chọn file",

            // Delete confirmation modal
            confirmDelete: "Xác nhận xóa",
            deleteConfirmMessage: "Bạn có chắc chắn muốn xóa media này?",
            mediaNotFound: "Không tìm thấy media",
            deleteError: "Xóa media thất bại",
            
            // Attribute management
            saveAttributes: "Lưu thuộc tính",
            saveAttributesTitle: "Lưu thuộc tính?",
            saveAttributesWarning:
                "Khi thuộc tính được lưu, chúng không thể sửa đổi sau này vì điều này sẽ ảnh hưởng đến các biến thể và đơn hàng. Bạn có chắc chắn muốn lưu các thuộc tính này?",
            attributesSaved: "Đã lưu thuộc tính thành công",
            attributeSaveError: "Không thể lưu thuộc tính",
            discardAttributesTitle: "Hủy thay đổi?",
            discardAttributesWarning:
                "Bạn có các thay đổi thuộc tính chưa được lưu. Bạn có chắc chắn muốn hủy bỏ chúng?",
            processingAttributes: "Đang xử lý...",
        },
    },
    order: {
        title: "Đơn hàng",
        status: "Trạng thái",
        pageSize: "Số dòng",
        basicInfo: "Thông tin đơn hàng",
        selectStatus: "Chọn trạng thái",
        fields: {
            orderId: "Mã đơn",
            customerName: "Khách hàng",
            customerPhone: "Điện thoại",
            customerEmail: "Email",
            customerAddress: "Địa chỉ",
            totalAmount: "Tổng tiền",
            status: "Trạng thái",
            createdAt: "Ngày tạo",
            productInfo: "Sản phẩm",
            quantity: "Số lượng",
            unitPrice: "Đơn giá",
            totalPrice: "Thành tiền",
            productId: "Mã sản phẩm",
            variantId: "Mã biến thể",
            paymentMethod: "Phương thức thanh toán",
            notes: "Ghi chú",
        },
        detailTitle: "Chi tiết đơn hàng",
        noOrders: "Không tìm thấy đơn hàng nào",
        noOrderSelected: "Chưa chọn đơn hàng",
        itemsPerPage: "Số mục mỗi trang",
        items: "Sản phẩm trong đơn hàng",
        customerInfo: "Thông tin khách hàng",
        updateStatus: "Cập nhật trạng thái",
        filter: {
            allStatuses: "Tất cả trạng thái"
        },

        search: {
            placeholder: "Tìm kiếm đơn hàng...",
            noResults: "Không tìm thấy đơn hàng phù hợp",
            searchError: "Lỗi tìm kiếm đơn hàng",
            searchSuccess: "Đã tìm thấy {{count}} đơn hàng",
            
        },

        // Status options
        statusOptions: {
            new: "Mới",
            shipping: "Đang giao hàng",
            completed: "Hoàn thành",
            cancelled: "Đã hủy",
            returned: "Đã trả hàng",
            refunded: "Đã hoàn tiền"
        },

        // Payment methods
        paymentMethods: {
            cod: "Thanh toán khi nhận hàng",
            credit: "Thẻ tín dụng",
            transfer: "Chuyển khoản ngân hàng",
            wallet: "Ví điện tử"
        },

        // Messages
        errorLoading: "Không thể tải dữ liệu đơn hàng",
        orderUpdated: "Cập nhật trạng thái đơn hàng thành công",
        deleteConfirm: "Bạn có chắc chắn muốn xóa đơn hàng này?",
        orderDeleted: "Đơn hàng đã được xóa thành công",
        orderSaved: "Đơn hàng đã được cập nhật thành công",
        validationError: "Tên khách hàng và số điện thoại là bắt buộc",
        thankYou: "Cảm ơn bạn!",
        successMessage: "Đơn hàng của bạn đã được đặt thành công.",
        orderNumber: "Mã đơn hàng",
        confirmationSent: "Chúng tôi đã gửi xác nhận đơn hàng đến số điện thoại của bạn.",
        trackingInfo: "Bạn sẽ nhận được thông tin về đơn hàng qua tin nhắn hoặc cuộc gọi.",
        continueToHome: "Tiếp tục mua sắm",
        statusPending: "Đang xử lý",
        statusProcessing: "Đang chuẩn bị hàng",
        statusShipping: "Đang giao hàng",
        statusCompleted: "Đã hoàn thành",
        statusCancelled: "Đã hủy",

        // Item related
        unknownProduct: "Sản phẩm không xác định",
        noItems: "Không có sản phẩm trong đơn hàng này",
    },
    storage: {
        title: "Quản lý lưu trữ",
        folders: "Thư mục",
        files: "Tệp tin",
        home: "Trang chủ",
        upload: "Tải lên tệp tin",
        uploading: "Đang tải lên...",
        uploadSuccess: "{count} tệp tin đã được tải lên thành công",
        uploadFailed: "Tải lên tệp tin thất bại",
        emptyFolder: "Thư mục này trống",
        fileDetails: "Chi tiết tệp tin",
        fileName: "Tên tệp",
        fileType: "Loại tệp",
        fileSize: "Kích thước",
        created: "Ngày tạo",
        modified: "Ngày sửa đổi",
        path: "Đường dẫn",
        url: "URL",
        urlCopied: "Đã sao chép URL vào bộ nhớ tạm",
        download: "Tải xuống",
        viewDetails: "Xem chi tiết",
        noPreview: "Loại tệp này không thể xem trước trực tiếp.",
        delete: "Xóa",
        confirmDelete: 'Bạn có chắc chắn muốn xóa "{name}"?',
        deleteSuccess: 'Đã xóa "{name}"',
        searchFolders: "Tìm kiếm thư mục...",
        dragToUpload: "Kéo và thả tệp tin hoặc nhấp để tải lên",
        viewMode: {
            list: "Xem dạng danh sách",
            grid: "Xem dạng lưới",
        },
    },
    chat: {
        title: "Quản lý trò chuyện",
        searchConversations: "Tìm kiếm cuộc trò chuyện...",
        noConversations: "Không tìm thấy cuộc trò chuyện nào",
        selectConversation: "Chọn một cuộc trò chuyện để bắt đầu",
        online: "Trực tuyến",
        away: "Vắng mặt",
        offline: "Ngoại tuyến",
        typeMessage: "Nhập tin nhắn...",
        sendMessage: "Gửi tin nhắn",
        messageSent: "Đã gửi tin nhắn",
        attachFiles: "Đính kèm tệp tin",
        emoji: "Biểu tượng cảm xúc",
        group: "Nhóm",
        moreOptions: "Thêm tùy chọn",
    },
    user: {
        title: "Quản lý người dùng",
        accessControl: "Kiểm soát truy cập hệ thống",
        allowAll: "Cho phép tất cả người dùng đăng nhập",
        restrictAccess:
            "Chỉ cho phép người dùng trong danh sách được đăng nhập",
        email: "Email",
        emailPlaceholder: "nguoidung@example.com",
        invalidGmail: "Vui lòng nhập địa chỉ Gmail hợp lệ",
        role: "Vai trò",
        add: "Thêm",
        edit: "Chỉnh sửa người dùng",
        whitelistedUsers: "Danh sách người dùng được phép",
        saveConfig: "Lưu cấu hình",
        saveSuccess: "Cấu hình người dùng đã được lưu thành công!",
        addSuccess: "Đã thêm người dùng thành công!",
        removeSuccess: "Đã xóa người dùng thành công!",
        emailRequired: "Email là bắt buộc",
        emailExists: "Người dùng với email này đã tồn tại",
        roleRequired: "Vai trò là bắt buộc",
        addError: "Không thể thêm người dùng",
        updateSuccess: "Cập nhật người dùng thành công",
        updateError: "Không thể cập nhật người dùng",
        removeError: "Không thể xóa người dùng",
        fetchError: "Không thể tải danh sách người dùng",
        noPermission: "Bạn không có quyền quản lý người dùng",
        deactivate: "VÔ HIỆU HÓA NGƯỜI DÙNG",
        activate: "KÍCH HOẠT NGƯỜI DÙNG",
        delete: "XÓA NGƯỜI DÙNG",
        activateSuccess: "Kích hoạt người dùng thành công",
        deactivateSuccess: "Vô hiệu hóa người dùng thành công",
        deleteConfirmMessage:
            "Bạn có chắc chắn muốn xóa {{email}}? Hành động này không thể hoàn tác.",
        roles: {
            root: "Quản trị cao cấp",
            admin: "Quản trị viên",
            content: "Quản lý nội dung",
            package: "Đóng gói sản phẩm",
        },
    },
    database: {
        title: "Quản lý cơ sở dữ liệu",
        tabs: {
            dataTables: "Bảng dữ liệu",
            sqlQuery: "Truy vấn SQL",
        },
        tables: {
            heading: "Các bảng dữ liệu",
            fetchError: "Không thể tải danh sách bảng dữ liệu",
            noTablesFound: "Không tìm thấy bảng dữ liệu",
        },
        query: {
            inputLabel: "Truy vấn SQL",
            placeholder:
                "Nhập truy vấn SQL của bạn (ví dụ: SELECT * FROM products LIMIT 10)",
            execute: "Thực thi",
            prompt: "Hỏi",
            results: "Kết quả truy vấn",
            runAgain: "Chạy lại",
            recordsReturned: "{{count}} bản ghi được trả về",
            noData: "Không có dữ liệu trả về",
            operation: "Thao tác",
            timestamp: "Thời gian",
        },
        prompt: {
            title: "Nhập yêu cầu",
            inputLabel: "Yêu cầu",
            placeholder: "Nhập yêu cầu của bạn tại đây...",
            process: "Xử lý",
        },
        tableView: {
            title: "Bảng",
            defaultTitle: "Dữ liệu bảng",
            live: "Trực tiếp",
            filter: "Lọc",
            filteredData: "{{filtered}} trên {{total}} bản ghi",
            showingRecords: "Hiển thị tối đa 100 bản ghi từ bảng",
            loadError: "Không thể tải dữ liệu bảng",
            noData: "Không có dữ liệu trong bảng này",
            editingCell: "Chỉnh sửa giá trị",
            noMatchingData: "Không có dữ liệu phù hợp với điều kiện lọc",
        },
        filter: {
            title: "Lọc dữ liệu",
            description:
                "Thêm điều kiện để lọc dữ liệu bảng. Tất cả điều kiện được kết hợp bằng logic AND.",
            addCondition: "Thêm điều kiện",
            clearFilters: "Xóa bộ lọc",
            cancel: "Hủy",
            apply: "Áp dụng bộ lọc",
            column: "Cột",
            operator: "Toán tử",
            value: "Giá trị",
            contains: "chứa",
            equals: "=",
            startsWith: "bắt đầu bằng",
            endsWith: "kết thúc bằng",
            greaterThan: ">",
            lessThan: "<",
            clearAll: "Xóa tất cả",
            applied: "Bộ lọc đã áp dụng",
            noConditions:
                'Không có điều kiện lọc. Nhấp "Thêm điều kiện" để tạo bộ lọc.',
            applyFilters: "Áp dụng bộ lọc",
        },
        edit: {
            error: {
                noPrimaryKey:
                    "Không thể cập nhật: Không tìm thấy khóa chính cho bảng này",
                updateFailed: "Cập nhật thất bại:",
                genericError: "Lỗi cập nhật ô:",
            },
        },
    },
    validation: {
        required: "Trường này là bắt buộc",
        fullNameRequired: "Vui lòng nhập họ và tên",
        phoneRequired: "Vui lòng nhập số điện thoại",
        addressRequired: "Vui lòng nhập địa chỉ giao hàng",
        addressMinLength: "Địa chỉ phải có ít nhất 5 ký tự",
        addressMinLengthInfo: "Tối thiểu 5 ký tự",
        invalidPhone: "Số điện thoại không hợp lệ",
        invalidEmail: "Email không hợp lệ"
    },
    footer: {
        description: "Thử thách tài chính vui nhất hệ mặt trời\n- Phát triển bởi NGƯỜI NGHÈO CHẤT -",
        quickLinks: "Truy cập nhanh",
        contactInfo: "Thông tin liên hệ",
        hotline: "Đường dây nóng",
        email: "Email",
        address: "Địa chỉ",
        copyright: "Tất cả các quyền được bảo lưu.",
    },
    home: {
        featuredCategories: "Danh mục nổi bật",
        category1: "Danh mục 1",
        category2: "Danh mục 2",
        category3: "Danh mục 3",
        category4: "Danh mục 4",
        featuredProducts: "Sản phẩm nổi bật",
        productName: "Sản phẩm {{id}}",
        productDescription: "Mô tả ngắn về sản phẩm.",
        viewAllProducts: "Xem tất cả sản phẩm",
        testimonials: "Khách hàng nói gì về chúng tôi",
        testimonialText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. Sed euismod, nisl vel ultricies tincidunt, nisl nisl aliquam nisl, eget aliquam nisl nisl sit amet nisl.",
        customerName: "Khách hàng {{id}}",
        customerLocation: "Địa điểm {{id}}",
    },
    cart: {
        title: "Giỏ hàng",
        empty: "Giỏ hàng của bạn đang trống",
        emptyDescription: "Có vẻ như bạn chưa thêm sản phẩm nào vào giỏ hàng.",
        continueShopping: "Tiếp tục mua sắm",
        items: "{{count}} sản phẩm trong giỏ hàng",
        subtotal: "Tạm tính",
        shipping: "Phí vận chuyển",
        discount: "Giảm giá",
        tax: "Thuế",
        total: "Tổng cộng",
        checkout: "Tiến hành đặt hàng",
        deliveryInfo: "Thông tin giao hàng",
        fullName: "Họ và tên",
        phone: "Số điện thoại",
        address: "Địa chỉ giao hàng",
        email: "Email (Không bắt buộc)",
        notes: "Ghi chú đơn hàng (Không bắt buộc)",
        confirmOrder: "Xác nhận đơn hàng",
        confirmYourOrder: "Xác nhận đơn hàng của bạn",
        orderConfirmation: "Xác nhận đơn hàng",
        customerInfo: "Thông tin khách hàng",
        orderItems: "Sản phẩm đã đặt",
        paymentPolicy: "Đơn hàng này sẽ được giao COD (Thanh toán khi nhận hàng). Bạn sẽ thanh toán khi nhận được sản phẩm.",
        placeOrder: "Xác nhận & Đặt hàng",
        orderSuccess: "Đơn hàng của bạn đã được đặt thành công! Mã đơn hàng: {{orderNumber}}",
        orderError: "Đã xảy ra lỗi khi đặt hàng. Vui lòng thử lại.",
        quantity: "Số lượng",
        unitPrice: "Đơn giá",
        itemTotal: "Thành tiền",
        summary: "Tổng kết đơn hàng",
        
        // Thêm các mục dịch cho trang giỏ hàng
        backToCart: "Quay lại giỏ hàng",
        removeItem: "Xóa sản phẩm",
        updateQuantity: "Cập nhật số lượng",
        paymentMethod: "Phương thức thanh toán",
        cod: "Thanh toán khi nhận hàng (COD)",
        orderPlaced: "Đơn hàng đã được đặt thành công!",
        processingOrder: "Đang xử lý đơn hàng của bạn",
        pleaseWait: "Vui lòng đợi trong giây lát...",
        confirmPlace: "Đặt hàng",
        orderSummary: "Tổng quan đơn hàng",
        product: "Sản phẩm",
        price: "Giá",
        addressPlaceholder: "Vui lòng nhập đầy đủ địa chỉ (ít nhất 5 ký tự)",
        addToCart: "Thêm vào giỏ hàng",
        buyNow: "Mua ngay",
        productAdded: "Đã thêm sản phẩm vào giỏ hàng",
        goToCart: "Đi đến giỏ hàng",
        update: "Cập nhật",
        remove: "Xóa",
        applyCoupon: "Áp dụng mã giảm giá",
        couponCode: "Mã giảm giá",
        apply: "Áp dụng",
        invalidCoupon: "Mã giảm giá không hợp lệ hoặc đã hết hạn",
        couponApplied: "Đã áp dụng mã giảm giá: {{code}}",
        estimatedTotal: "Tổng thanh toán dự kiến",
        itemsInCart: "Sản phẩm trong giỏ hàng",
        outOfStock: "Hết hàng",
        lowStock: "Chỉ còn {{count}} sản phẩm",
        freeTaxes: "Miễn thuế",
        freeShipping: "Miễn phí vận chuyển",
        thankYouForOrder: "Cảm ơn bạn đã đặt hàng!",
    },
};
